Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Media3843945918",
  {"root":"Media3843945918--root","emptyRoot":"Media3843945918--emptyRoot","description":"Media3843945918--description","title":"Card1528630649--title"},
  "",
  12,
  "Media3843945918"
);

